import React, { useState, useEffect } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { useSelector, useDispatch } from "react-redux";
import { GetParserHeadDetailsAction, SetParserHeadFurtherDetailsAction } from "../../../redux/actions/companyAction";

function ParserHead() {
    const [loading, setloading] = useState(true);
    const [selectedRow, setselectedRow] = useState([]);
    const dispatch = useDispatch();

    const parseHeadDetails = useSelector((state) => state.companySlice?.parseHeadDetails);

    const onRowSelect = (event) => {
        console.log(event.data);
        dispatch(SetParserHeadFurtherDetailsAction(event.data));
    };

    const getParserHeadDetails = () => {
        dispatch(GetParserHeadDetailsAction("zbizgateway/nonFin/getAllParsers"));
    };

    useEffect(() => {
        getParserHeadDetails();
    }, []); // eslint-disable-line

    const statusBody = (rowData) => {
        return <div>{rowData?.isActive === "Y" ? "Yes" : "No"}</div>;
    };

    useEffect(() => {
        if (parseHeadDetails) {
            setloading(false);
        }
    }, [parseHeadDetails]);

    return (
        <div>
            <div className="card p-datatable-sm">
                <DataTable
                    header="Company Linked Parser Head"
                    selection={selectedRow}
                    onSelectionChange={(e) => setselectedRow(e.value)}
                    selectionMode="single"
                    dataKey="parserHeadId"
                    onRowSelect={onRowSelect}
                    loading={loading}
                    paginator
                    rows={10}
                    value={parseHeadDetails}
                    emptyMessage="No data found."
                >
                    <Column filter field="tblProduct.masterProductName" header="Product Name" />
                    <Column filter field="code" header="Code" />
                    <Column filter field="description" header="Description" />
                    <Column filter field="isActive" body={statusBody} header="Active" />
                </DataTable>
            </div>
        </div>
    );
}

export default ParserHead;
